module.exports = __webpack_public_path__ + "h5/img/scan_activity_img.fef4b17c.jpg";